export default __webpack_public_path__ + "static/media/about-hero.35ae43e9.png";